module.exports = "/_next/static/images/923714846b5df12b52d03eb276863092-slide-3-small.png";